import React from "react";
import { GridWrapper } from "../../GridWrapper/GridWrapper";
import { Card } from "../../card";
import { StudentResultInfo } from "./StudentResultInfo";
import { StudentResultform } from "./StudentResultForm";
import {
  setPaginatedStudentResultList,
  setSelectedStudentForResult,
} from "../../../Redux/Slices/studentResuilt.slice";
import { getValue } from "../../../utils/object.utils";
import { useGetStudentListForResult } from "../../../hooks/resultsHooks/studentResult.hooks";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../Redux/store";
import { Loader } from "../../loader/Loader";

interface Props {
  resultId: number;
}
export const StudentResult = ({ resultId }: Props) => {
  const dispatch = useDispatch();

  const { pageNo } = useSelector((state: RootState) => ({
    selectedStudent: state.studentResult.selectedStudentForResult,
    pageNo: state.studentResult.pageNo,
  }));

  const { isLoading } = useGetStudentListForResult({
    resultId,
    page: pageNo,
    onSuccess: (data) => {
      dispatch(setPaginatedStudentResultList(data));
      const defaultSeletctedStudent = getValue(data, "result.[0]", null);
      dispatch(setSelectedStudentForResult(defaultSeletctedStudent));
    },
  });

  if (isLoading) return <Loader isLoading={isLoading} />;

  return (
    <GridWrapper
      totalColumns={3}
      childrens={[
        {
          component: (
            <Card wrapperStyle={{ height: "100%" }} cardTitle="Students list">
              <div>
                <StudentResultInfo />
              </div>
            </Card>
          ),
          gridSpan: 1,
        },
        {
          component: (
            <Card
              wrapperStyle={{ height: "100%" }}
              cardTitle="Student result form"
            >
              <StudentResultform resultId={resultId} />
            </Card>
          ),
          gridSpan: 2,
        },
      ]}
    />
  );
};
